import { render, staticRenderFns } from "./AccionesWrapper.vue?vue&type=template&id=22caa05d&scoped=true&"
import script from "./AccionesWrapper.vue?vue&type=script&lang=js&"
export * from "./AccionesWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AccionesWrapper.vue?vue&type=style&index=0&id=22caa05d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22caa05d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22caa05d')) {
      api.createRecord('22caa05d', component.options)
    } else {
      api.reload('22caa05d', component.options)
    }
    module.hot.accept("./AccionesWrapper.vue?vue&type=template&id=22caa05d&scoped=true&", function () {
      api.rerender('22caa05d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/AccionesWrapper.vue"
export default component.exports